import { cva } from 'class-variance-authority';

export const tabsListVariants = cva(
  'inline-flex h-9 items-center justify-center',
  {
    variants: {
      variant: {
        default: 'bg-muted text-muted-foreground p-[3px] w-fit',
        underline: 'w-full border-b border-border/40 justify-start',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const tabsTriggerVariants = cva(
  'inline-flex items-center justify-center gap-1.5 whitespace-nowrap text-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 font-bold',
  {
    variants: {
      variant: {
        default: [
          'h-[calc(100%-1px)] flex-1 rounded-md border border-transparent px-2 py-1',
          'data-[state=active]:bg-background data-[state=active]:shadow-sm',
          'data-[state=active]:text-foreground',
          'dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30',
        ],
        underline: [
          'border-b-[3px] border-transparent px-4 pb-3 -mb-[1px]',
          'text-muted-foreground/70',
          'data-[state=active]:border-ihs-blue',
          'data-[state=active]:text-ihs-blue',
          'hover:text-foreground',
          'mr-6',
        ],
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
